import Sidebar from "../../components/sidebar/Sidebar";
import Routes from "./DashboardRoutes";
import Layout from "./Layout";

const Dashboard: React.FC = () => {
  return (
    // <div className="flex">
    //   <Sidebar />
    //   <div className="px-5 2xl:px-10 flex-1 sm:ml-60 md:ml-64 xl:ml-72 overflow-y-auto bg-dim_gray min-h-screen">
    //     <Routes />
    //   </div>
    // </div>
    <Layout />
  );
};

export default Dashboard;
